import * as React from "react";
const SvgFiBrandsCharacter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-character_svg__a)">
      <path
        fill="#151A2D"
        d="M19.75.3H4.25C1.9.3 0 2.2 0 4.55v14.9c0 2.35 1.9 4.25 4.25 4.25h15.5c2.35 0 4.25-1.9 4.25-4.25V4.55C24 2.2 22.1.3 19.75.3M11.6 6.55v1.81c0 .1-.04.13-.11.1-.3-.14-.63-.24-.96-.29-1.024-.155-2.101-.155-3.03.36-1.082.599-1.629 1.803-1.61 3.01.019 1.18.498 2.359 1.56 2.96.915.519 2.013.597 3.04.46.3-.04.59-.11.87-.22.04-.03.07-.04.1-.02.02.03.03.07.02.11v1.66c.01.1-.04.19-.13.23-.31.11-.62.18-.95.22-1.009.12-2.052.105-3.04-.15-1.638-.424-3.013-1.606-3.5-3.25-.466-1.547-.372-3.373.44-4.79 1.025-1.788 3.114-2.677 5.12-2.64.42 0 .83.02 1.25.06.29.03.57.1.85.19.06.05.09.12.08.19m8.39 10.1c0 .1-.04.14-.13.14h-1.89c-.08.01-.15-.04-.16-.12v-4.54c.01-.29-.04-.58-.15-.85-.09-.2-.23-.38-.42-.51-.22-.13-.48-.19-.74-.18-.24 0-.48.03-.71.1-.22.09-.43.2-.61.34v5.64c0 .09-.04.13-.11.13h-2.01c-.07.01-.13-.04-.14-.11V5.54c0-.07.04-.11.13-.11h2.03c.05-.01.11.03.11.08v.03l.01 3.8c.29-.19.6-.35.93-.47.653-.238 1.46-.195 2.12-.01.748.21 1.225.744 1.5 1.45.16.41.24.95.24 1.6z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-character_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCharacter;
